'use client';

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 1320px;
  margin: 0 auto;
  gap: 16px;

  @media (max-width: 1320px) {
    max-width: 936px;
  }

  @media (max-width: 936px) {
    max-width: 618px;
  }
`;
